var map = {
	"./add.png": "d1da",
	"./arrow_left_outline_grey.png": "2842",
	"./arrow_left_outline_white.png": "0b88",
	"./arrow_right_outline_grey.png": "9bd6",
	"./arrow_right_outline_white.png": "5b92",
	"./background_off.png": "a0d7",
	"./background_on.png": "6ea1",
	"./background_ready..png": "75ec",
	"./background_ready.png": "5540",
	"./bars_white.png": "4739",
	"./bookmark_grey_outline.png": "fe91",
	"./bookmark_white.png": "2747",
	"./bookmark_white_circle.png": "59c5",
	"./bookmark_white_outline.png": "d30e",
	"./button_box.png": "e141",
	"./button_box_down.png": "1e09",
	"./button_box_up.png": "10f8",
	"./button_chart_circle.png": "7222",
	"./button_chart_white.png": "3abf",
	"./button_check.png": "55d5",
	"./button_check_blue.png": "d680",
	"./button_check_disabled.png": "55a6",
	"./button_check_off.png": "c6d9",
	"./button_close.png": "a554",
	"./button_close_dark.png": "500f",
	"./button_close_grey.png": "2490",
	"./button_close_search.png": "060d",
	"./button_delete.png": "5dbf",
	"./button_delete_dark.png": "3e38",
	"./button_down.png": "aa9a",
	"./button_down_dark.png": "0ee6",
	"./button_file.png": "66b8",
	"./button_grid.png": "389c",
	"./button_left.png": "f6ae",
	"./button_left_dark.png": "36ae",
	"./button_left_line.png": "b333",
	"./button_list.png": "b136",
	"./button_list_disabled.png": "b5b0",
	"./button_max.png": "481e",
	"./button_min.png": "9b77",
	"./button_off.png": "26a7",
	"./button_on.png": "4f33",
	"./button_pause.png": "5798",
	"./button_phone.png": "3d2a",
	"./button_ready.png": "b9ca",
	"./button_reload.png": "2fa2",
	"./button_reload_dark.png": "e7be",
	"./button_reload_some.png": "d644",
	"./button_right.png": "ec6e",
	"./button_right_dark.png": "2fd4",
	"./button_right_line.png": "3f28",
	"./button_search.png": "b470",
	"./button_search_dark.png": "2b8a",
	"./button_share.png": "06fe",
	"./button_share_dark_arrow.png": "957d",
	"./button_share_old.png": "edcc",
	"./button_sidebar.png": "da5b",
	"./button_sort_asc.png": "7294",
	"./button_sort_desc.png": "acbc",
	"./button_up.png": "4940",
	"./button_up_dark.png": "b50e",
	"./button_user_circle.png": "6a3f",
	"./card/group-outlet_cykel.png": "bb85",
	"./card/group-outlet_mc.png": "5f39",
	"./card/modelpicker.png": "7811",
	"./check-circle.png": "2165",
	"./circle.png": "088b",
	"./circle_dark.png": "1c32",
	"./circle_downloaded.png": "0240",
	"./circle_grey_arrow_left.png": "10ec",
	"./circle_help_dark_grey.png": "e593",
	"./circle_help_grey.png": "3f4c",
	"./circle_help_white.png": "f66e",
	"./circle_off.png": "e522",
	"./circle_pause.png": "8572",
	"./circle_play.png": "cda7",
	"./circle_recover.png": "50f7",
	"./circle_spinner.png": "fc16",
	"./circle_trash.png": "73b1",
	"./circle_trash_check.png": "330e",
	"./circle_trash_delete.png": "d438",
	"./circle_trash_recover.png": "bb5c",
	"./circle_white_desktop.png": "c3d8",
	"./circle_white_expand.png": "110b",
	"./circle_white_expanded.png": "b445",
	"./circle_white_mobile.png": "48b6",
	"./copy_circle_white.png": "baa6",
	"./copy_trash_circle_white.png": "ea25",
	"./copy_trash_white.png": "bdf4",
	"./copy_trash_white_circle.png": "4db3",
	"./current_darkgrey_off.png": "4dba",
	"./current_darkgrey_on.png": "a169",
	"./current_off.png": "4671",
	"./current_on.png": "a6f7",
	"./debug.png": "ffde",
	"./downloaded.png": "239c",
	"./error_orange.png": "bdea",
	"./error_red.png": "6a35",
	"./error_white.png": "eb20",
	"./floppy_white.png": "e719",
	"./history.png": "5bf3",
	"./history_dark.png": "4429",
	"./icon-copy.png": "abfe",
	"./icon-cykel.png": "2bc8",
	"./icon-cykel_dark.png": "5249",
	"./icon-cykel_off.png": "ca5e",
	"./icon-history.png": "0f00",
	"./icon-mc.png": "b79c",
	"./icon-mc_dark.png": "05bc",
	"./icon-mc_off.png": "ee17",
	"./icon-motul.png": "e44d",
	"./icon-motul_dark.png": "2c86",
	"./icon.png": "555a",
	"./layout_cols.png": "cc5c",
	"./layout_rows.png": "2bf7",
	"./layout_rows_50.png": "c1a0",
	"./logo-patch_black.png": "1540",
	"./logo.png": "cf05",
	"./logo_black.png": "36b4",
	"./logo_white.png": "428c",
	"./move_down.png": "f219",
	"./move_up.png": "bd88",
	"./off_grey.png": "7eaa",
	"./on_grey.png": "4411",
	"./popup_white.png": "8791",
	"./pro.png": "8514",
	"./scroll_circle_left.png": "0719",
	"./scroll_circle_right.png": "71ef",
	"./sort_asc.png": "aef6",
	"./sort_desc.png": "a13f",
	"./sort_none.png": "5df5",
	"./spinner.png": "e337",
	"./trash.png": "c8e4",
	"./trash_check.png": "3333",
	"./trash_delete.png": "6d92",
	"./trash_recover.png": "de34",
	"./trash_white.png": "00c7",
	"./w3_add_add.png": "50d4",
	"./w3_add_black.png": "6781",
	"./w3_add_dark.png": "28bd",
	"./w3_add_light.png": "d879",
	"./w3_add_white.png": "9f6c",
	"./w3_bars_black.png": "5b97",
	"./w3_bars_dark.png": "dd5e",
	"./w3_bars_light.png": "8230",
	"./w3_bars_white.png": "cc57",
	"./w3_bil_black.png": "1094",
	"./w3_bil_dark.png": "26af",
	"./w3_bil_grey.png": "e02a",
	"./w3_bil_light.png": "e71c",
	"./w3_bil_white.png": "50d2",
	"./w3_bookmark_black.png": "64ca",
	"./w3_bookmark_dark.png": "373c",
	"./w3_bookmark_grey.png": "459c",
	"./w3_bookmark_light.png": "c5c3",
	"./w3_bookmark_solid_black.png": "c06c",
	"./w3_bookmark_solid_dark.png": "4119",
	"./w3_bookmark_solid_grey.png": "dbd4",
	"./w3_bookmark_solid_light.png": "c9f7",
	"./w3_bookmark_solid_white.png": "408d",
	"./w3_bookmark_square_black.png": "169c",
	"./w3_bookmark_square_dark.png": "17f1",
	"./w3_bookmark_square_grey.png": "0ac2",
	"./w3_bookmark_square_light.png": "0c48",
	"./w3_bookmark_square_white.png": "89c9",
	"./w3_bookmark_white.png": "e39e",
	"./w3_button_check_black.png": "23d8",
	"./w3_button_check_dark.png": "04b8",
	"./w3_button_check_light.png": "1f8d",
	"./w3_button_check_white.png": "984d",
	"./w3_button_close_black.1c590089.png": "c4f8",
	"./w3_button_close_black.png": "f3c3",
	"./w3_button_close_dark.4e3c2332.png": "0f59",
	"./w3_button_close_dark.png": "eddd",
	"./w3_button_close_light.aff057e9.png": "4885",
	"./w3_button_close_light.png": "0b58",
	"./w3_button_close_white.36e223a1.png": "c0ca",
	"./w3_button_close_white.png": "b96b",
	"./w3_button_reload_grey.a2e4b2ab.png": "397f",
	"./w3_button_reload_grey.png": "bf16",
	"./w3_button_reload_grey_light.c485b6cb.png": "ea78",
	"./w3_button_reload_grey_light.png": "a6b8",
	"./w3_button_reload_light.png": "d9c4",
	"./w3_cart_black.png": "0efc",
	"./w3_cart_dark.png": "83ab6",
	"./w3_cart_grey.png": "9f2e",
	"./w3_cart_light.png": "4c85",
	"./w3_cart_white.png": "b129",
	"./w3_check_black.png": "b629",
	"./w3_check_circle_black.png": "c6d7",
	"./w3_check_circle_dark.png": "07f8",
	"./w3_check_circle_grey.png": "02ef",
	"./w3_check_circle_light.png": "c2e5",
	"./w3_check_circle_white.png": "43b6",
	"./w3_check_dark.png": "9e47",
	"./w3_check_light.png": "333c",
	"./w3_check_white.png": "6a0f",
	"./w3_chevron_down_black.8197cfb8.png": "5939",
	"./w3_chevron_down_black.png": "0433",
	"./w3_chevron_down_dark.cdc86b2e.png": "33cf",
	"./w3_chevron_down_dark.png": "9337",
	"./w3_chevron_down_grey.png": "497f",
	"./w3_chevron_down_light.5e71551c.png": "3260",
	"./w3_chevron_down_light.png": "dd98",
	"./w3_chevron_down_red.png": "950e",
	"./w3_chevron_down_white.85633abf.png": "d3c7",
	"./w3_chevron_down_white.png": "fc06",
	"./w3_chevron_left_black.3dcd09f6.png": "f8fe",
	"./w3_chevron_left_black.png": "2039",
	"./w3_chevron_left_dark.e87c73fb.png": "8025",
	"./w3_chevron_left_dark.png": "c74a",
	"./w3_chevron_left_light.d324fb6f.png": "599b",
	"./w3_chevron_left_light.png": "d0d9",
	"./w3_chevron_left_white.3c99ae2f.png": "bb65",
	"./w3_chevron_left_white.png": "defa",
	"./w3_chevron_right_black.1836242f.png": "5922",
	"./w3_chevron_right_black.png": "cd5f",
	"./w3_chevron_right_dark.5f60accc.png": "d4ae",
	"./w3_chevron_right_dark.png": "e2e2",
	"./w3_chevron_right_light.01f74951.png": "7ac5",
	"./w3_chevron_right_light.png": "af5f",
	"./w3_chevron_right_white.7d52371e.png": "ec21",
	"./w3_chevron_right_white.png": "b3c4",
	"./w3_chevron_up_black.e46d9f06.png": "1d42",
	"./w3_chevron_up_black.png": "dc69",
	"./w3_chevron_up_dark.ec238f5f.png": "51a7",
	"./w3_chevron_up_dark.png": "9359",
	"./w3_chevron_up_grey.png": "f9fa",
	"./w3_chevron_up_light.f7a1d3a6.png": "897d",
	"./w3_chevron_up_light.png": "1ffd",
	"./w3_chevron_up_red.png": "7e3b",
	"./w3_chevron_up_white.0ed03193.png": "d4db",
	"./w3_chevron_up_white.png": "2b09",
	"./w3_circle_add_black.png": "4ae7",
	"./w3_circle_add_dark.png": "4b78",
	"./w3_circle_add_light.png": "c477",
	"./w3_circle_add_white.png": "c6dd",
	"./w3_circle_bars_black.png": "de01",
	"./w3_circle_bars_dark.png": "5b19",
	"./w3_circle_bars_light.png": "faed",
	"./w3_circle_bars_white.png": "a5c9",
	"./w3_circle_black.png": "035d",
	"./w3_circle_close_black.9c6a4972.png": "1ff2",
	"./w3_circle_close_black.png": "2fcf",
	"./w3_circle_close_dark.e7c44c4e.png": "78e6",
	"./w3_circle_close_dark.png": "1d91",
	"./w3_circle_close_light.png": "ed05",
	"./w3_circle_close_white.png": "4b8a",
	"./w3_circle_dark.png": "2e8a",
	"./w3_circle_down_black.122986fb.png": "1925",
	"./w3_circle_down_black.png": "eb3b",
	"./w3_circle_down_dark.7caf8551.png": "6c6b",
	"./w3_circle_down_dark.png": "1dc5",
	"./w3_circle_down_grey.32c80c51.png": "3504",
	"./w3_circle_down_grey.png": "d81f",
	"./w3_circle_down_light.97d88c11.png": "0c13",
	"./w3_circle_down_light.png": "3b5c",
	"./w3_circle_down_white.c7952a55.png": "91cd",
	"./w3_circle_down_white.png": "7b63",
	"./w3_circle_filter_black.d637af78.png": "0a89",
	"./w3_circle_filter_black.png": "cbe8",
	"./w3_circle_filter_dark.d547da77.png": "7995",
	"./w3_circle_filter_dark.png": "4cc6",
	"./w3_circle_filter_grey.eb454983.png": "8f78",
	"./w3_circle_filter_grey.png": "fc93",
	"./w3_circle_filter_light.767099b1.png": "f57b",
	"./w3_circle_filter_light.png": "a136",
	"./w3_circle_filter_white.68df9aec.png": "59ac",
	"./w3_circle_filter_white.png": "0b3b",
	"./w3_circle_grid_black.3a45e48c.png": "a0fe",
	"./w3_circle_grid_black.png": "7825",
	"./w3_circle_grid_dark.d386ebd8.png": "3318",
	"./w3_circle_grid_dark.png": "e3be",
	"./w3_circle_grid_light.84969b00.png": "0a94",
	"./w3_circle_grid_light.png": "8580",
	"./w3_circle_grid_white.3ef6f218.png": "6b0f",
	"./w3_circle_grid_white.png": "cf45",
	"./w3_circle_gridlist_black.3cce02d3.png": "2b5f",
	"./w3_circle_gridlist_black.png": "abdb",
	"./w3_circle_in_stock_black.png": "e094",
	"./w3_circle_in_stock_dark.png": "e69f",
	"./w3_circle_in_stock_green.png": "655e",
	"./w3_circle_in_stock_grey.png": "9960",
	"./w3_circle_in_stock_light.png": "814d",
	"./w3_circle_left_black.png": "6562",
	"./w3_circle_left_dark.png": "bf3f",
	"./w3_circle_left_grey.png": "1bb0",
	"./w3_circle_left_light.png": "ce39",
	"./w3_circle_left_white.png": "4ed1",
	"./w3_circle_light.png": "38d4",
	"./w3_circle_list_black.67812b74.png": "1e8d",
	"./w3_circle_list_black.png": "0c09",
	"./w3_circle_list_dark.9ae6d84f.png": "2e98",
	"./w3_circle_list_dark.png": "1ba0",
	"./w3_circle_list_image_black.6f22b7e7.png": "9756",
	"./w3_circle_list_image_black.png": "7d92",
	"./w3_circle_list_image_dark.ddadb64c.png": "d9a0",
	"./w3_circle_list_image_dark.png": "6365",
	"./w3_circle_list_image_light.a60fb9a9.png": "78b4",
	"./w3_circle_list_image_light.png": "6abb",
	"./w3_circle_list_image_white.9d80f56a.png": "7523",
	"./w3_circle_list_image_white.png": "dda4",
	"./w3_circle_list_light.9f5160d2.png": "14e9",
	"./w3_circle_list_light.png": "bc4a",
	"./w3_circle_list_white.515b0c85.png": "20da",
	"./w3_circle_list_white.png": "f466",
	"./w3_circle_pause_black.png": "9b8f",
	"./w3_circle_pause_dark.png": "5d31",
	"./w3_circle_pause_grey.png": "2335",
	"./w3_circle_pause_light.png": "85cb",
	"./w3_circle_pause_white.png": "f48b",
	"./w3_circle_reload_black.png": "b653",
	"./w3_circle_reload_dark.png": "26fe",
	"./w3_circle_reload_light.png": "ecd8",
	"./w3_circle_reload_white.png": "e371",
	"./w3_circle_right_black.png": "4a3f",
	"./w3_circle_right_dark.png": "cbd2",
	"./w3_circle_right_grey.png": "c0e1",
	"./w3_circle_right_light.png": "0c9a",
	"./w3_circle_right_white.png": "e422",
	"./w3_circle_trash_black.png": "90b2",
	"./w3_circle_trash_check_black.png": "f9ef",
	"./w3_circle_trash_check_dark.png": "863d",
	"./w3_circle_trash_check_light.png": "22ba",
	"./w3_circle_trash_check_white.png": "f503",
	"./w3_circle_trash_dark.png": "b2fe",
	"./w3_circle_trash_delete_black.png": "6642",
	"./w3_circle_trash_delete_dark.png": "a245",
	"./w3_circle_trash_delete_light.png": "a2a4",
	"./w3_circle_trash_delete_white.png": "e7db",
	"./w3_circle_trash_light.png": "366c",
	"./w3_circle_trash_recover_black.png": "1da1",
	"./w3_circle_trash_recover_dark.png": "02f2",
	"./w3_circle_trash_recover_light.png": "58aa",
	"./w3_circle_trash_recover_white.png": "6005",
	"./w3_circle_trash_white.png": "f391",
	"./w3_circle_up_black.ae13a5f0.png": "4ebe",
	"./w3_circle_up_black.png": "749e",
	"./w3_circle_up_dark.8e8c453a.png": "6048",
	"./w3_circle_up_dark.png": "671c",
	"./w3_circle_up_grey.fac1ca0e.png": "14a6",
	"./w3_circle_up_grey.png": "b677",
	"./w3_circle_up_light.93f35d2d.png": "4d73",
	"./w3_circle_up_light.png": "9a7c",
	"./w3_circle_up_white.22aed970.png": "ebb4",
	"./w3_circle_up_white.png": "68e8",
	"./w3_circle_white.png": "da07",
	"./w3_close_all_white.png": "0a00",
	"./w3_close_black.png": "ccf9",
	"./w3_close_dark.png": "c4c7",
	"./w3_close_light.png": "ac9c",
	"./w3_close_white.png": "0001",
	"./w3_cloud_black.png": "739f",
	"./w3_cloud_dark.png": "18ed",
	"./w3_cloud_grey.png": "08b9",
	"./w3_cloud_light.png": "17da",
	"./w3_cloud_white.png": "b6ec",
	"./w3_copy_black.png": "ae06",
	"./w3_copy_white.png": "3cf3",
	"./w3_cykel_black.png": "bd5f",
	"./w3_cykel_dark.png": "4c1b",
	"./w3_cykel_grey.png": "f82a",
	"./w3_cykel_light.png": "d85d",
	"./w3_cykel_white.png": "2393",
	"./w3_delivery_black.png": "98ac",
	"./w3_delivery_dark.png": "fa04",
	"./w3_delivery_grey.png": "7b62",
	"./w3_delivery_light.png": "f826",
	"./w3_delivery_white.png": "7b98",
	"./w3_dropship_black.png": "f297",
	"./w3_exclamation_black.png": "3216",
	"./w3_exclamation_dark.png": "3196",
	"./w3_exclamation_grey.png": "502e",
	"./w3_exclamation_light.png": "53fa",
	"./w3_exclamation_white.png": "5459",
	"./w3_facebook_white.png": "cdca",
	"./w3_filter_black.png": "e58c",
	"./w3_filter_dark.png": "38c3",
	"./w3_filter_grey.png": "af9e",
	"./w3_filter_light.png": "c986",
	"./w3_filter_white.png": "d793",
	"./w3_grid_black.png": "894b",
	"./w3_grid_dark.png": "9bc0",
	"./w3_grid_grey.png": "7e85",
	"./w3_grid_light.png": "ef90",
	"./w3_grid_white.png": "0918",
	"./w3_instagram_white.png": "7a05",
	"./w3_layout_column_white.png": "f12c",
	"./w3_layout_row_white.png": "3353",
	"./w3_layout_wrap_white.png": "2236",
	"./w3_link_black.png": "8c23",
	"./w3_link_dark.png": "2b5d",
	"./w3_link_grey.png": "aae9",
	"./w3_link_light.png": "4807",
	"./w3_link_white.png": "db36",
	"./w3_location_black.png": "5c17",
	"./w3_location_dark.png": "581b",
	"./w3_location_grey.png": "4ef5",
	"./w3_location_light.png": "10f5",
	"./w3_location_white.png": "f30d",
	"./w3_logout_black.png": "791e",
	"./w3_logout_dark.png": "60dd",
	"./w3_logout_grey.png": "1769",
	"./w3_logout_light.png": "e9f4",
	"./w3_logout_white.png": "aec4",
	"./w3_maximize_black.png": "1c33",
	"./w3_maximize_dark.png": "754f",
	"./w3_maximize_light.png": "8819",
	"./w3_maximize_list_white.png": "1e3c",
	"./w3_maximize_white.png": "c3a8",
	"./w3_mc_black.png": "e1fc",
	"./w3_mc_dark.png": "f282",
	"./w3_mc_grey.png": "3572",
	"./w3_mc_light.png": "5161",
	"./w3_mc_white.png": "78b5",
	"./w3_minimize_black.png": "069a",
	"./w3_minimize_dark.png": "630d",
	"./w3_minimize_light.png": "9a9a",
	"./w3_minimize_list_white.png": "ea39",
	"./w3_minimize_white.png": "a0d7a",
	"./w3_olja_black.png": "050c",
	"./w3_olja_dark.png": "a8cb",
	"./w3_olja_grey.png": "cab8",
	"./w3_olja_light.png": "7d8d",
	"./w3_olja_white.png": "184f",
	"./w3_outlet_black.png": "0b9b",
	"./w3_outlet_dark.png": "d038",
	"./w3_outlet_grey.png": "8859",
	"./w3_outlet_light.png": "2d90",
	"./w3_outlet_white.png": "24d5",
	"./w3_package_black.png": "96cd",
	"./w3_package_dark.png": "6e6a",
	"./w3_package_grey.png": "63ac",
	"./w3_package_light.png": "62dd",
	"./w3_package_thin_black.png": "402b",
	"./w3_package_thin_dark.png": "5899",
	"./w3_package_thin_grey.png": "9ca9",
	"./w3_package_thin_light.png": "f1e7",
	"./w3_package_thin_white.png": "f730",
	"./w3_package_white.png": "092d",
	"./w3_paste_black.png": "42e9",
	"./w3_paste_dark.png": "0897",
	"./w3_paste_light.png": "77d5",
	"./w3_paste_white.png": "d00b",
	"./w3_pause_black.png": "9670",
	"./w3_pause_dark.png": "3dca",
	"./w3_pause_light.png": "8f9c",
	"./w3_pause_white.png": "6605e",
	"./w3_pdf_black.png": "006f",
	"./w3_pdf_dark.png": "efed",
	"./w3_pdf_grey.png": "9e55",
	"./w3_pdf_light.png": "8f40",
	"./w3_pdf_white.png": "aefd",
	"./w3_percent_black.png": "4328",
	"./w3_percent_dark.png": "a2fd",
	"./w3_percent_grey.png": "98cf",
	"./w3_percent_light.png": "c360",
	"./w3_percent_white.png": "d68b",
	"./w3_phone_black.png": "5b9a",
	"./w3_phone_dark.png": "660a",
	"./w3_phone_grey.png": "48cb",
	"./w3_phone_light.png": "ba04",
	"./w3_phone_white.png": "f583",
	"./w3_question_black.png": "88aa",
	"./w3_question_dark.png": "681e",
	"./w3_question_grey.png": "7a53",
	"./w3_question_light.png": "3670",
	"./w3_question_white.png": "93c0",
	"./w3_reload_black.f66bd28c.png": "d459",
	"./w3_reload_black.png": "0480",
	"./w3_reload_dark.80730622.png": "f526",
	"./w3_reload_dark.png": "575f",
	"./w3_reload_grey.b55aa7b0.png": "e881",
	"./w3_reload_grey.png": "9023",
	"./w3_reload_light.9d7b70ba.png": "e2fe",
	"./w3_reload_light.png": "26c1",
	"./w3_reload_white.png": "08d5",
	"./w3_rocket_black.png": "09fa",
	"./w3_rocket_dark.png": "6c2a",
	"./w3_rocket_grey.png": "66d2",
	"./w3_rocket_light.png": "4505",
	"./w3_rocket_white.png": "43d2",
	"./w3_search_black.png": "9515",
	"./w3_search_dark.png": "8c92",
	"./w3_search_grey.png": "6e4f",
	"./w3_search_light.png": "1c71",
	"./w3_search_lighter.png": "2db0",
	"./w3_search_white.png": "74e3",
	"./w3_share_black.png": "f3ca",
	"./w3_share_dark.png": "fd69",
	"./w3_share_light.png": "8a11",
	"./w3_share_white.png": "6909",
	"./w3_show_all_white.png": "e9b7",
	"./w3_sort_bars_asc_black.png": "9599",
	"./w3_sort_bars_asc_dark.png": "b864",
	"./w3_sort_bars_asc_light.png": "6571",
	"./w3_sort_bars_asc_white.png": "70d2",
	"./w3_sort_bars_desc_black.png": "a93f",
	"./w3_sort_bars_desc_dark.png": "2d63",
	"./w3_sort_bars_desc_light.png": "15c3",
	"./w3_sort_bars_desc_white.png": "9799",
	"./w3_sort_black.png": "f3f2",
	"./w3_sort_dark.png": "c31f",
	"./w3_sort_light.png": "9416",
	"./w3_sort_white.png": "614a",
	"./w3_spinner_black.72a67cba.png": "137a",
	"./w3_spinner_black.png": "8477",
	"./w3_spinner_dark.ecb78263.png": "c503",
	"./w3_spinner_dark.png": "1d3e",
	"./w3_spinner_grey.png": "b56f",
	"./w3_spinner_light.f1ce62de.png": "2417",
	"./w3_spinner_light.png": "23ae",
	"./w3_spinner_white.613d434c.png": "04be6",
	"./w3_spinner_white.png": "1e1d",
	"./w3_startspinner_dots.png": "7a19",
	"./w3_store_black.png": "06f8",
	"./w3_store_dark.png": "9b0c",
	"./w3_store_grey.png": "556c",
	"./w3_store_light.png": "aac0",
	"./w3_store_white.png": "af86",
	"./w3_subset_black.png": "28e7",
	"./w3_subset_dark.png": "0328",
	"./w3_subset_grey.png": "cbbc",
	"./w3_subset_light.png": "5504",
	"./w3_subset_white.png": "0697",
	"./w3_technical_black.png": "580c",
	"./w3_technical_dark.png": "d9db",
	"./w3_technical_light.png": "8f3e",
	"./w3_technical_white.png": "2484",
	"./w3_translate_black.png": "fe93",
	"./w3_translate_dark.png": "b48e",
	"./w3_translate_light.png": "f52b",
	"./w3_translate_white.png": "311b",
	"./w3_trash_black.7a38d4ac.png": "bdd2",
	"./w3_trash_black.png": "6faa",
	"./w3_trash_dark.b6b9861f.png": "7ecb",
	"./w3_trash_dark.png": "dee2",
	"./w3_trash_delete_black.png": "88d0",
	"./w3_trash_delete_dark.png": "9ce4",
	"./w3_trash_delete_grey.png": "53fa5",
	"./w3_trash_delete_light.png": "1087",
	"./w3_trash_delete_white.png": "c869",
	"./w3_trash_grey.png": "206f",
	"./w3_trash_light.12a6f619.png": "c3bb",
	"./w3_trash_light.png": "de91",
	"./w3_trash_recover_black.png": "2b0e",
	"./w3_trash_recover_dark.png": "c696",
	"./w3_trash_recover_grey.png": "6a93",
	"./w3_trash_recover_light.png": "f40a",
	"./w3_trash_recover_white.png": "e529",
	"./w3_trash_solid_black.png": "7635",
	"./w3_trash_solid_dark.png": "cb39",
	"./w3_trash_solid_delete_black.png": "01cb",
	"./w3_trash_solid_delete_dark.png": "3c02",
	"./w3_trash_solid_delete_light.png": "27d0",
	"./w3_trash_solid_delete_white.png": "6d7f",
	"./w3_trash_solid_light.png": "ae90",
	"./w3_trash_solid_recover_black.png": "f118",
	"./w3_trash_solid_recover_dark.png": "15c5",
	"./w3_trash_solid_recover_light.png": "8557",
	"./w3_trash_solid_recover_white.png": "251a",
	"./w3_trash_solid_white.png": "3f77",
	"./w3_trash_white.f82e28dd.png": "fbdb",
	"./w3_trash_white.png": "d532",
	"./w3_user_black.png": "d78a",
	"./w3_user_dark.png": "e9f5",
	"./w3_user_grey.png": "add3",
	"./w3_user_light.png": "0744",
	"./w3_user_white.png": "8f2f",
	"./w3_viewed_black.png": "2254",
	"./w3_viewed_dark.png": "9779",
	"./w3_viewed_grey.png": "b197",
	"./w3_viewed_light.png": "7bd3",
	"./w3_viewed_white.png": "428e",
	"./white_desktop.png": "6d06",
	"./white_mobile.png": "15fc",
	"./widescreen_off.png": "d71b",
	"./widescreen_on.png": "7692"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";